import { Link } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import { useEffect } from 'react';
import FreeTrialBanner from '@/components/FreeTrial/FreeTrialBanner';

export default function GetStartedPage() {
  const { userAttributes } = useAuth();

  // For this page, we want to scroll to the top of the page when the component mounts
  // so that the user sees the content from the beginning of the page rather than being
  // scrolled down to the middle or bottom of the page where it could be confusing.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full h-full overflow-auto">
      <div className="w-900 mx-auto content-wrapper">
        <FreeTrialBanner />
        <div className="flex justify-between mb-40 items-center">
          <h1 className="text-h1 text-secondary-navy-500">Help & Support</h1>
          <div className="flex gap-8">
            <Link className="btn btn-neutral btn-sm" to="https://scribl.co/faq" target="_blank">
              See FAQ
            </Link>
            <Link
              className="btn btn-neutral btn-sm"
              to="https://forms.gle/q9hBq8ZfEUh1gPBZ8"
              target="_blank"
            >
              Give Feedback
            </Link>
            <Link className="btn btn-neutral btn-sm" to="mailto:info@scribl.co" target="_blank">
              Contact Support
            </Link>
          </div>
        </div>
        <section id="getting-started" className="mb-56">
          <h2 className="text-h2 mb-24">Getting Started</h2>
          <p className="text-body mb-24">
            Welcome to Scribl, {userAttributes?.given_name}! We&apos;re excited to have you join us.
          </p>
          <p className="text-body mb-24">
            Every meeting is an opportunity to build relationships. Scribl offers teams a quick,
            simple tool to more effectively foster personal connection, broaden participation, and
            spur creative thinking.
          </p>
          <p className="text-body">
            Whether you use one of our curated prompts or create your own, Scribl empowers
            individuals and organizations to thrive in a fun and meaningful way.
          </p>
        </section>
        <section id="faq-section" className="mb-56">
          <h2 className="text-h2 mb-24">Tips for a Great Session</h2>
          <p className="text-body mb-16">
            Here are some tips to help you make the most of your Scribl session.
          </p>
          <ul className="list-disc list-inside">
            <li className="text-body">Make sure you have a stable internet connection.</li>
            <li className="text-body">Have a quiet, well-lit space to play in.</li>
            <li className="text-body">
              If you are playing remotely, it is encouraged to keep cameras on to help build
              community.
            </li>
            <li className="text-body">Be ready to engage with your fellow participants.</li>
            <li className="text-body">
              Be considerate of others and what they share. Scribl is a safe space for everyone to
              feel comfortable and included.
            </li>
          </ul>
        </section>
        <section id="transitional-paragraph" className="mb-40">
          <h2 className="text-h2 mb-24">Ready to Get Started?</h2>{' '}
          <p className="text-body">
            Ready to take the next step? Click the button below to get started with hosting your own
            Scribl session or to access your dashboard.
          </p>
        </section>
        <div className="flex flex-col items-center">
          <Link to="/dashboard/host" className="btn btn-primary">
            Launch a Game
          </Link>
        </div>
      </div>
    </div>
  );
}
